import {createContext, useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {TYPE_DEFAULT, TYPE_FIMLAB, TYPE_GTI, TYPE_VIDEO_CONFERENCE} from "../../../../../../definitions/TimelineItems";
import {getInstructions, hasInstructions} from "../../../../../../utils/TimelineUtils";
import {linkkipalveluSelector} from "../../../../../../data/selector";
import {connect} from "react-redux";


export const TimelineFrameInstructionsContext = createContext(null);
const TimelineFrameContentInstructionsWrapper = ({children, linkkipalvelu}) => {
    const { data } = useContext(TimelineFrameDataContext);

    const checkAndGetInstructions = () => {
        if(data?.config?.type === "imaging" && data?.config?.instructions) {
            return data.config.instructions;
        } else if (data.type === TYPE_FIMLAB) {
            return {};
        } else {
            return hasInstructions(data, linkkipalvelu) && getInstructions(data, linkkipalvelu);
        }
    }

    let instructions = checkAndGetInstructions();

    if (data?.config?.appointmentSpecificLocationLink) {
        if (!instructions) {
            instructions = [];
        }

        if (data?.config?.type !== "imaging") {
            if (instructions && instructions[0] && instructions[0].length > 0) {
                instructions = [[...instructions[0], data.config.appointmentSpecificLocationLink]];
            } else {
                instructions[0] = [data.config.appointmentSpecificLocationLink];
            }
        } else {
            instructions = [...instructions, data.config.appointmentSpecificLocationLink];
        }

    }

    if ((!instructions || instructions.length === 0) &&
        (!data?.config?.appointmentSpecificInstructions || data.config.appointmentSpecificInstructions.length === 0)) {
        return null;
    }

    return (
      <TimelineFrameInstructionsContext.Provider value={instructions}>
          {children}
      </TimelineFrameInstructionsContext.Provider>
    );

}

const mapStateToProps = (state) => {
    let linkkipalvelu = linkkipalveluSelector(state);
    return {
        linkkipalvelu
    }
}

export default connect(mapStateToProps)(TimelineFrameContentInstructionsWrapper);